// extracted by mini-css-extract-plugin
module.exports = {"cl_primary_btn":"Button_cl_primary_btn__RtACF","cl_secondary_btn":"Button_cl_secondary_btn__oB3Rx"};